import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';
import { AllResultTypes, ResultTypes } from '@trackman/baseball-shared-components';
import { Hotkeys } from 'constants/Hotkeys';

export const ResultOptions: ITaggingFlowOption[] = [
  {
    displayName: 'Stolen Base',
    value: AllResultTypes.StolenBase,
    hotkeyCode: Hotkeys.Result.StolenBase.hotkeyCode,
    hotkeyDisplay: Hotkeys.Result.StolenBase.hotkeyDisplay,
  },
  {
    displayName: 'Caught Stealing',
    value: AllResultTypes.CaughtStealing,
    hotkeyCode: Hotkeys.Result.CaughtStealing.hotkeyCode,
    hotkeyDisplay: Hotkeys.Result.CaughtStealing.hotkeyDisplay,
  },
  {
    displayName: 'Nothing',
    value: ResultTypes.Undefined,
    hotkeyCode: Hotkeys.Result.Nothing.hotkeyCode,
    hotkeyDisplay: Hotkeys.Result.Nothing.hotkeyDisplay,
  },
];
